export const preloadImage = (src: string): void => {
  let img = new Image()
  img.src = src
  // When image is loaded and cached in the browser, prepare the not needed anymore Image object for garbage collection
  img.onload = () => (img = undefined)
}

export const isImageCached = (src: string): boolean => {
  let img = new Image()
  img.src = src
  // Check if object is immediately loaded from browser cache
  const isCached = img.complete
  // Prepare not needed Image object for garbage collection
  img = undefined

  return isCached
}
